
  import termsQuery from '@/apollo/queries/general/termsQuery'
  import pageMeta from '~/mixins/pageMeta.js';

  export default {
    name: "terms",

    mixins: [pageMeta],

    data() {
      return {
        pageData: Object,
        loading: 0,
      };
    },
    apollo: {
      $loadingKey: "loading",
      pageData: {
        prefetch: true,
        query: termsQuery,
        variables() {
          return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
        },
        update(data) {
          return this.$normalizeStrapi(data.termsOfUse.data);
        },
      },
    },
    computed: {
      sectionBanner(){
        const bannerObject = {Title: this.pageData.Banner.BannerText};
        return bannerObject;
      }
    },
    methods: {

    },
  }
